import { render, staticRenderFns } from "./ChunkUpload.vue?vue&type=template&id=a82855c2&scoped=true"
import script from "./ChunkUpload.vue?vue&type=script&lang=js"
export * from "./ChunkUpload.vue?vue&type=script&lang=js"
import style0 from "./ChunkUpload.vue?vue&type=style&index=0&id=a82855c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82855c2",
  null
  
)

export default component.exports